<div class="inbuilt-datasource">
    <div class="inbuilt-datasource__header">
        <span class="inbuilt-datasource__icon">
            <mat-icon aria-hidden="true">storage</mat-icon>
        </span>
        <h2 class="inbuilt-datasource__title">Select data source</h2>
    </div>
    <p class="inbuilt-datasource__description">
        Choose the source that will power this report before adding filters or visuals.
    </p>
    <button type="button" class="inbuilt-datasource__button" [disabled]="hasDataSource" (click)="open()">
        <mat-icon aria-hidden="true">add</mat-icon>
        <span>Select data source</span>
    </button>
</div>

<app-modal [maximizable]="true" [inViewport]="true" #selectDatasourceModal
    class="modal-demo select-datasource-popup" (closeModal)="onModalCancelled()">
    <ng-container class="app-modal-header">
        <div class="select-datasource-popup__heading">
            <span class="select-datasource-popup__title">Select data source</span>
            <span class="select-datasource-popup__subtitle">
                Choose one or more datasets and the columns that will power this report.
            </span>
        </div>
    </ng-container>
    <ng-container class="app-modal-body">
        <app-select-datasource-modal #dsBody [hasReportAdminRole]="hasReportAdminRole" [reportNameFromQueryParams]="reportNameFromQueryParams"
            (apply)="onModalApply($event)" (cancelled)="onModalCancelled()"></app-select-datasource-modal>
    </ng-container>
    <ng-container class="app-modal-footer">
        <div class="select-datasource-popup__footer">
            <span class="select-datasource-popup__summary">{{ dsBody.summaryText }}</span>
            <div class="select-datasource-popup__actions">
                <button type="button" class="select-datasource-popup__btn select-datasource-popup__btn--secondary"
                    (click)="dsBody.onCancel()">
                    Cancel
                </button>
                <button type="button" class="select-datasource-popup__btn select-datasource-popup__btn--primary"
                    [disabled]="!dsBody.canApply || dsBody.isSubmitting" (click)="dsBody.onApply()">
                    Apply
                </button>
            </div>
        </div>
    </ng-container>
</app-modal>
